
import Vue from "vue";
import { format } from "date-fns";
import { BillingClient } from "@/lib/clients";
import { BillingInfo, CreatePortalSessionInput } from "@/lib/models/billing";
import PaymentDescription from "@/components/organisms/subscription/PaymentDescription.vue";
import CreditCardOutlineIcon from "icons/CreditCardOutline.vue";
import { mapGetters } from "vuex";

const billingClient = new BillingClient();

export default Vue.extend<Data, Methods, Computed, Props>({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },

  components: {
    CreditCardOutlineIcon,
    PaymentDescription,
  },

  async created() {
    window.scrollTo(0, 0);

    await this.$store.dispatch("billingModule/fetchBillingInfo");
  },

  data() {
    return {
      navigatePath: "unsubscriptionAnnounce",
    };
  },

  computed: {
    ...mapGetters("billingModule", ["hasPaymentError"]),
    billingInfo() {
      return this.$store.getters["billingModule/billingInfo"] as BillingInfo;
    },
    isFree() {
      const { billingInfo } = this;
      return billingInfo?.plan === 0;
    },
    billingPlatformName() {
      const { billingInfo } = this;
      if (billingInfo?.platform) {
        return "App";
      }
      return "Web";
    },
    cardLast4() {
      return this.billingInfo?.cardInfo?.last4;
    },
    cardExpYear() {
      return this.billingInfo?.cardInfo?.exp_year;
    },
    cardExpMonth() {
      return this.billingInfo?.cardInfo?.exp_month;
    },
    planPrice() {
      const { billingInfo } = this;
      if (billingInfo) {
        switch (billingInfo.plan) {
          default:
          case 0:
            return "0";
          case 1:
            return "300";
          case 2:
            return "2,800";
        }
      }
      return "0";
    },
    planCurrentPeriodEnd() {
      const { billingInfo } = this;
      const { subscription } = billingInfo;
      if (subscription && subscription.currentPeriodEnd) {
        return format(subscription.currentPeriodEnd, "YYYY/MM/DD");
      }
      return undefined;
    },
    subscriptionRenewalTitle() {
      const { billingInfo } = this;
      if (billingInfo?.subscription?.isAutoRenewal) {
        return "次回更新日";
      }
      return "有効期限";
    },
  },

  methods: {
    async onClickModifyPaymentInfo() {
      const payload: CreatePortalSessionInput = {
        returnUrl: `${window.location.origin}/payment-management`,
      };
      const session = await billingClient.createPortalSession(payload);

      window.location.href = session.url;
    },
    onClickUpgrade() {
      this.$router.push({ name: "subscriptionAnnounce" });
    },
  },

  watch: {
    billingInfo: {
      handler(value) {
        this.navigatePath = getNavigatePath(value);
      },
      deep: true,
    },
  },
});

function getNavigatePath(billingInfo: BillingInfo) {
  switch (billingInfo.platform) {
    case "ios":
    case "android":
      return "confirmInAppPurchase";
    default:
      return "unsubscriptionAnnounce";
  }
}

interface Props {}

interface Data {
  navigatePath: string;
}

interface Computed {
  billingInfo: BillingInfo;
  isFree: boolean;
  billingPlatformName: string;
  cardLast4: string;
  cardExpYear: string;
  cardExpMonth: string;
  planPrice?: string;
  planCurrentPeriodEnd?: string;
  subscriptionRenewalTitle: string;
  hasPaymentError: boolean;
}

interface Methods {
  onClickModifyPaymentInfo(): Promise<void>;
  onClickUpgrade(): void;
}
